module.exports = __webpack_public_path__ + "img/202312_04.0c81e480.jpg";